import React, { useRef, useState } from 'react'
import Link from 'next/link'
import { ChevronDown, ChevronUp } from '@next-nx/shared-ui/icons'
import { useTealium } from '@next-nx/hooks'
import { getTimestamp, getAnchorRel } from '@next-nx/utils'
import styles from './CittaAccordion.module.sass'
import { FilialeType } from '@next-nx/utils/types'

interface Props {
  regione: string
  items: FilialeType[]
  className?: string
}

const CittaAccordion = (props: Props) => {
  const { regione, items = [], className = '' } = props

  const [open, setOpen] = useState(false)
  const innerContentRef = useRef(null)
  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type: string, cta: string = '') => {
    const action_timestamp = getTimestamp()

    linkDataLayer({
      virtual: 'action',
      action_name: 'storelocator',
      action_tech: 'click',
      action_type: action_type.replace(/ /g, '_').toLowerCase(),
      action_timestamp,
      action_effect: 'filiali_interazione_citta',
      cta: cta?.replace(/ /g, '_').toLowerCase(),
    })
  }

  return regione ? (
    <div className={`${styles.root} ${className}`}>
      <p className={styles.title}>{regione}</p>
      <button className={styles.trigger} onClick={() => setOpen(!open)}>
        <span>{regione}</span>
        <span className={styles.triggerIcon}>{open ? <ChevronUp /> : <ChevronDown />}</span>
      </button>
      <div
        className={styles.list}
        style={{
          maxHeight: innerContentRef?.current && open ? innerContentRef.current.clientHeight : 0,
        }}
      >
        <div className={styles.innerContent} ref={innerContentRef}>
          {items.map((y) => (
            <Link href={y.url || ''} key={y.pk}>
              <a
                className={styles.item}
                rel={getAnchorRel(y.url || '')}
                onClick={() => handleTracking(regione, y.titolo)}
              >
                {y.titolo}
              </a>
            </Link>
          ))}
        </div>
      </div>
    </div>
  ) : (
    <></>
  )
}

export default CittaAccordion
